import { useSelector } from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type RequiredPreloadedState from '@alltrails/core/types/RequiredPreloadedState';

const useAppSelector: TypedUseSelectorHook<RequiredPreloadedState> = useSelector;

export default useAppSelector;
